<template>
  <div class="h-100 d-flex center-xy">
    <b-col sm="12" md="8" lg="6" xl="4">
      <h1>403</h1>
      <b-card class="mb-4">
        <h2 class="mb-4">Acesso Negado!!!</h2>
        <p class="center-xy">
          Você não tem permissão para acessar esta área.<br />
          Por favor, vá para a página inicial e tente novamente.
        </p>
      </b-card>
    </b-col>
  </div>

</template>

<script>
export default {
  name: 'AccessDenied',
  methods: {
    goHome () {
      window.location.href = '/'
    }
  }
}
</script>
<style scoped lang="scss">
html,
body {
  height: 100% !important;
  border: 5px solid blue !important;
}
h1 {
  font-size: 10rem;
  color: #252932;
  font-weight: bolder;
  text-align: center;
  text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px,
    rgba(61, 61, 61, 0.3) 3px 3px;
}
h2 {
  text-align: center;
  font-weight: bolder;
}
</style>
